export const uriToId = (uri) => {
    return uri.split('/').pop();
}
